type Order<S> = { before: S; at: S; after: S };

/**
 * Resolves a step's state from its position relative to the selected step unless the caller
 * set one explicitly. With no selected step every step is upcoming.
 */
export const deriveState = <S>(
  explicit: S | undefined,
  index: number,
  selectedIndex: number,
  order: Order<S>,
): S => {
  if (explicit) return explicit;
  if (selectedIndex === -1 || index > selectedIndex) return order.after;
  if (index === selectedIndex) return order.at;

  return order.before;
};
